import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom'; // <-- STEP 1: Import createPortal
import { XIcon } from './XIcon';

export const InfoModal = ({ isOpen, onClose, title, content, position }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const modalContent = (
    <div ref={modalRef} className="info-modal-popup" style={{ top: position.top, left: position.left }}>
      <div className="info-modal-header"><h3 className="info-modal-title">{title}</h3><button onClick={onClose} className="info-modal-close-btn"><XIcon /></button></div>
      <div className="info-modal-content">{content}</div>
      <div className="info-modal-footer"><button onClick={onClose} className="info-modal-ok-btn">OK</button></div>
    </div>
  );

  return createPortal(modalContent, document.body);
};